import PropTypes from 'prop-types';

import YouTubeVideo from '../shared-components/video/YouTubeVideo.component';
import { POLL_VIDEO_TYPES } from '../../helpers/constants';

/**
 * Widget-level video for a Voting Poll — one video shown above the options.
 * Renders only when the poll response says poll_video_type === 'widget'.
 *
 * @param {object} props - component props
 * @param {object} props.poll - the poll data
 * @returns {object|null} the video block, or null
 */
function PollVideo({ poll }) {
    if (
        poll?.poll_video_type !== POLL_VIDEO_TYPES.WIDGET ||
        !poll.youtube_video_id
    ) {
        return null;
    }

    return (
        <div
            data-cy="poll-video"
            style={{ margin: '16px auto -8px', maxWidth: '892px' }}
        >
            <YouTubeVideo
                videoId={poll.youtube_video_id}
                title={poll?.questions?.[0]?.text || 'Poll video'}
            />
        </div>
    );
}

PollVideo.propTypes = {
    poll: PropTypes.object.isRequired
};

export default PollVideo;
